{
    "title": "Application Rejected",
    "subtitle": "Please contact us to help you with your onboarding process again",
    "instructions": "Contact us in support@izziwallet.com.br"
}